import ReactDOM from 'react-dom';
import React from 'react';
import AppRoot from './index';
import { configureStore, getParams } from './store';
import connectPromise from './connect-promise';

const renderRootElement = document.getElementById('app-container');
const renderRootComponent = (AppRootComponent, { store, history, contentId, contentPlugin }) => {
	return (
		<AppRootComponent
			store={store}
			history={history}
			contentId={contentId}
			contentPlugin={contentPlugin}
		/>
	);
};

connectPromise.then(configureStore).then((configuredStore) => {
	ReactDOM.render(
		renderRootComponent(AppRoot, { ...configuredStore, ...getParams() }),
		renderRootElement,
	);

	// Setup for hot-reloading React components - using React Hot Loader 3.
	if (module.hot) {
		module.hot.accept('./index', () => {
			const NextAppRoot = require('./index').default;
			ReactDOM.render(renderRootComponent(NextAppRoot), renderRootElement);
		});
	}
});
